import { FC } from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { SxProps, Theme } from '@mui/material';
import { PickerValue } from '@mui/x-date-pickers/internals';
import { useFormikContext } from 'formik';

interface Props {
  className?: string;
  name: string;
  label?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  ampm?: boolean;
  views?: Array<'hours' | 'minutes' | 'seconds'>;
  sx?: SxProps<Theme>;
}

export const QcsTimePicker: FC<Props> = ({ className, name, label, onChange, disabled, ampm = false, views = ['hours', 'minutes'], sx }) => {
  const { setFieldValue, values } = useFormikContext<Record<string, string | undefined>>();

  const handleChange = (value?: PickerValue) => {
    if (onChange) onChange(parseTime(value) ?? '');
    setFieldValue(name, parseTime(value) ?? '');
  };

  const parseTime = (val?: PickerValue): string | null => {
    if (!val || isNaN(val.getTime())) {
      return null;
    }
    const hours = val.getHours().toString().padStart(2, '0');
    const minutes = val.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const timeStr = values[name];
  const dateVal = timeStr ? new Date(`1970-01-01T${timeStr}`) : null;

  return (
    <TimePicker
      className={className}
      ampm={ampm}
      views={views}
      label={label}
      value={dateVal}
      onChange={handleChange}
      disabled={disabled}
      sx={sx}
      css={{ backgroundColor: '#fff' }}
    />
  );
};
